/* NOTFORTOMORROW OS2.0 - contact globe.
   A compact rotating dotted sphere drawn on a <canvas>, vanilla, zero deps.
   ~760 points distributed via the golden-spiral (Fibonacci) method, projected and
   rotated each frame with requestAnimationFrame. Lime (#9AE048) dots on a transparent
   ground. Pauses when offscreen (IntersectionObserver) and when the tab is hidden.
   Respects prefers-reduced-motion: renders one static frame, no animation loop.
   No em-dash anywhere. Self-initialising for every [data-globe] canvas. */
(function () {
  'use strict';

  var LIME = '#9AE048';
  var POINTS = 760;
  var TILT = -0.42;          // fixed forward tilt (radians)
  var SPEED = 0.0021;        // base spin per frame (50% slower for a calmer rotation)
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function buildSphere(n) {
    // Fibonacci / golden-spiral distribution -> near-even points on a unit sphere.
    var pts = new Array(n);
    var phi = Math.PI * (3 - Math.sqrt(5)); // golden angle
    for (var i = 0; i < n; i++) {
      var y = 1 - (i / (n - 1)) * 2;        // y in [1, -1]
      var r = Math.sqrt(Math.max(0, 1 - y * y));
      var theta = phi * i;
      pts[i] = [Math.cos(theta) * r, y, Math.sin(theta) * r];
    }
    return pts;
  }

  function Globe(canvas) {
    var ctx = canvas.getContext('2d');
    if (!ctx) return;
    var pts = buildSphere(POINTS);
    var angle = 0;
    var raf = null;
    var visible = true;
    var size = 0, cx = 0, cy = 0, radius = 0, dpr = 1;

    function resize() {
      var rect = canvas.getBoundingClientRect();
      size = Math.max(1, Math.min(rect.width, rect.height));
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.round(size * dpr);
      canvas.height = Math.round(size * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      cx = size / 2;
      cy = size / 2;
      radius = size * 0.44;
    }

    function draw() {
      ctx.clearRect(0, 0, size, size);
      var sinA = Math.sin(angle), cosA = Math.cos(angle);
      var sinT = Math.sin(TILT), cosT = Math.cos(TILT);
      for (var i = 0; i < pts.length; i++) {
        var x = pts[i][0], y = pts[i][1], z = pts[i][2];
        // spin around Y
        var x1 = x * cosA - z * sinA;
        var z1 = x * sinA + z * cosA;
        // tilt around X
        var y2 = y * cosT - z1 * sinT;
        var z2 = y * sinT + z1 * cosT;
        // simple perspective: depth in [-1, 1] -> [0, 1]
        var depth = (z2 + 1) / 2;
        var px = cx + x1 * radius;
        var py = cy + y2 * radius;
        var dotR = (0.55 + depth * 1.45) * (size / 360);
        ctx.globalAlpha = 0.18 + depth * 0.82;
        ctx.beginPath();
        ctx.arc(px, py, Math.max(0.4, dotR), 0, Math.PI * 2);
        ctx.fillStyle = LIME;
        ctx.fill();
      }
      ctx.globalAlpha = 1;
    }

    function frame() {
      angle += SPEED;
      draw();
      raf = window.requestAnimationFrame(frame);
    }

    function start() {
      if (reduce || raf !== null) return;
      raf = window.requestAnimationFrame(frame);
    }
    function stop() {
      if (raf !== null) { window.cancelAnimationFrame(raf); raf = null; }
    }

    resize();
    draw(); // static first frame (also the reduced-motion frame)

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () { resize(); draw(); }, 120);
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else if (visible) { start(); }
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          visible = e.isIntersecting;
          if (visible && !document.hidden) { start(); } else { stop(); }
        });
      }, { threshold: 0.05 });
      io.observe(canvas);
    } else {
      start();
    }
  }

  function init() {
    var nodes = document.querySelectorAll('[data-globe]');
    for (var i = 0; i < nodes.length; i++) { new Globe(nodes[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
